import {
  Box,
  SystemStyleObject,
  ThemeTypings,
  chakra,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import * as React from 'react';
import { Footer } from 'ui-components';
import { EmailNotVerifiedNotification } from '~/components/EmailNotVerifiedNotification';
import { Feature } from '~/components/Feature';
import { ManagedCreatorInvitationList } from '~/components/ManagedCreatorInvitationList';
import { TopBar } from '~/components/TopBar';
import { TryNewFoamBanner } from '~/components/TryNewFoamBanner';
import VisibleForRoles from '~/components/VisibleForRoles';
import { FEATURE_FLAGS } from '~/constants';

export interface LoggedLayoutProps {
  __css?: SystemStyleObject;
  __cssContent?: SystemStyleObject;
  backgroundColor?: ThemeTypings['colorSchemes'];
  bottom?: React.ReactNode;
  children?: React.ReactNode;
  showEmailNotVerifiedNotification?: boolean;
  top?: React.ReactNode;
  topBar?: React.ReactNode;
  variant?: 'compact' | 'restricted' | 'fluid';
  /* Show layout for specific role (currently show creator tools bar or not) */
  userVariant?: 'creator' | 'manager'; // Default is 'manager'. "creator" accounts for both creator user and manager as creator
}

export const LoggedLayout: React.FC<LoggedLayoutProps> = ({
  __css,
  __cssContent,
  bottom,
  backgroundColor,
  children,
  showEmailNotVerifiedNotification = true,
  top,
  topBar,
  variant = 'fluid',
  userVariant = 'manager',
}) => {
  const styles = useMultiStyleConfig('Layout', { variant });

  return (
    <chakra.div __css={styles.root}>
      <Feature name={FEATURE_FLAGS.foamTryFluid}>
        <TryNewFoamBanner />
      </Feature>
      <TopBar userVariant={userVariant} />
      {top}

      <chakra.main
        __css={{ ...styles.main, ...__css }}
        backgroundColor={backgroundColor}
      >
        {topBar}

        <chakra.div __css={{ ...styles.content, ...__cssContent }}>
          <VisibleForRoles creator managed>
            <Box paddingX={{ base: 3, md: 0 }}>
              <ManagedCreatorInvitationList />
            </Box>
          </VisibleForRoles>

          {children}
        </chakra.div>

        {showEmailNotVerifiedNotification && <EmailNotVerifiedNotification />}
      </chakra.main>

      {bottom}
      <Footer />
    </chakra.div>
  );
};
